(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[914],{

/***/ 593:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[handle]",
      function () {
        return __webpack_require__(2468);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Collection; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9312);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(2680);
// EXTERNAL MODULE: ./src/hooks/index.js + 63 modules
var hooks = __webpack_require__(4124);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(1157);
// EXTERNAL MODULE: ./src/templates/collection/CollectionGrid/index.js + 10 modules
var CollectionGrid = __webpack_require__(6469);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(3355);
;// CONCATENATED MODULE: ./src/templates/collection/SeoFooter/SeoFooter.theme.js

var themed = (0,create/* create */.U)(new function() {}());

;// CONCATENATED MODULE: ./src/templates/collection/SeoFooter/SeoFooter.jsx






var SeoFooter = themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    var router = (0,dist.useRouter)();
    var settings = (0,dist.useSettings)();
    var groups = settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.seo) === null || ref1 === void 0 ? void 0 : ref1.groups;
    var handle = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.handle;
    var seoText = (0,react.useMemo)(function() {
        if (!(groups === null || groups === void 0 ? void 0 : groups.length)) return null;
        var group = groups.find(function(param) {
            var collections = param.collections;
            return collections === null || collections === void 0 ? void 0 : collections.includes(handle);
        });
        return (group === null || group === void 0 ? void 0 : group.body) || null;
    }, [
        JSON.stringify(groups),
        handle
    ]);
    return seoText ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SeoFooter.displayName,
        sx: {
            gridArea: "footer"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
            text: seoText,
            textSx: {
                variant: "text.base",
                fontSize: [
                    3,
                    4
                ],
                lineHeight: [
                    20,
                    22
                ]
            }
        })
    }) : null;
});
SeoFooter.displayName = "SeoFooter";

;// CONCATENATED MODULE: ./src/templates/collection/SeoFooter/index.js


// EXTERNAL MODULE: ./src/templates/collection/hooks/index.js + 4 modules
var collection_hooks = __webpack_require__(4174);
// EXTERNAL MODULE: ./src/templates/collection/Filters/CurrentFilters.jsx + 1 modules
var CurrentFilters = __webpack_require__(4903);
;// CONCATENATED MODULE: ./src/templates/collection/Filters/DesktopFilters/DesktopFilters.theme.js



var DesktopFilters_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        gridArea: "filters",
        display: [
            "none",
            "contents"
        ]
    };
    this.sticky = {
        top: [
            "var(--header-height)"
        ],
        position: "sticky",
        bg: "white",
        zIndex: 2,
        gridArea: "filters"
    };
    this.heading = function(hasLongWord) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            variant: "text.h2",
            mb: "28px",
            overflowWrap: "break-word"
        }, hasLongWord ? {
            fontSize: "28px"
        } : {}), {
            gridArea: "title"
        });
    };
    this.accordionHeader = {
        heading: {
            variant: "text.label.1",
            display: "inline-block"
        },
        selected: {
            variant: "text.base",
            textTransform: "none",
            display: "inline",
            color: "mediumDarkGray",
            ml: 4
        }
    };
    this.clearButton = {
        mt: 10
    };
}());

;// CONCATENATED MODULE: ./src/templates/collection/Filters/DesktopFilters/DesktopFilters.jsx







var DesktopFilters = DesktopFilters_theme_themed(function(param) {
    var theme = param.theme, collection = param.collection, collectionCategories = param.collectionCategories, merchandising = param.merchandising, hasHero = param.hasHero;
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,collection_hooks/* useCollectionFilters */.PY)(), 2), filters = ref3[0].filters, ref4 = ref3[1], addToSelectedFilters = ref4.addToSelectedFilters, removeFromSelectedFilters = ref4.removeFromSelectedFilters;
    var left = merchandising === null || merchandising === void 0 ? void 0 : (ref = merchandising.content) === null || ref === void 0 ? void 0 : (ref1 = ref.left) === null || ref1 === void 0 ? void 0 : ref1[0];
    var words = (ref2 = collection.title) === null || ref2 === void 0 ? void 0 : ref2.split(" ");
    var hasLongWord = words === null || words === void 0 ? void 0 : words.some(function(word) {
        return (word === null || word === void 0 ? void 0 : word.length) > 8;
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": DesktopFilters.displayName,
        sx: theme.wrapper,
        children: [
            !hasHero && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h1",
                sx: theme.heading(hasLongWord),
                children: collection === null || collection === void 0 ? void 0 : collection.title
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.sticky,
                children: [
                    collectionCategories,
                    (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordions */.FV, {
                        textColor: "text",
                        borderColor: "gray",
                        iconColor: "text",
                        minHeight: "52px",
                        maxHeight: "800px",
                        oneOpenAtATime: false,
                        children: filters === null || filters === void 0 ? void 0 : filters.map(function(filter) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Accordion */.UQ, {
                                collapsed: !!filter.collapse,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordion.Header */.UQ.Header, {
                                        sx: theme.accordionHeader.heading,
                                        children: filter.label
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordion.Body */.UQ.Body, {
                                        children: function(param) {
                                            var isOpen = param.isOpen;
                                            var ref;
                                            return (ref = filter.values) === null || ref === void 0 ? void 0 : ref.map(function(option) {
                                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                    as: "li",
                                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* FilterOption */.f2, {
                                                        option: option,
                                                        field: filter.field,
                                                        tabIndex: isOpen ? "0" : "-1",
                                                        "aria-hidden": isOpen ? "false" : "true",
                                                        addToSelectedFilters: addToSelectedFilters,
                                                        removeFromSelectedFilters: removeFromSelectedFilters
                                                    })
                                                }, option.label);
                                            });
                                        }
                                    })
                                ]
                            }, filter.label);
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CurrentFilters/* CurrentFilters */.c, {}),
                    left && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        dangerouslySetInnerHTML: {
                            __html: left
                        },
                        sx: {
                            mt: 12,
                            display: [
                                "none",
                                "block"
                            ]
                        }
                    })
                ]
            })
        ]
    });
});
DesktopFilters.displayName = "DesktopFilters";

;// CONCATENATED MODULE: ./src/templates/collection/Filters/DesktopFilters/index.js


;// CONCATENATED MODULE: ./src/templates/collection/Filters/MobileFilters/MobileFilters.theme.js

var MobileFilters_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: [
            "contents",
            "none"
        ]
    };
    this.heading = {
        variant: "text.h1",
        px: 8,
        my: 10
    };
    this.grid = {
        gridTemplateColumns: "1fr",
        gridGap: 0,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.button = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        position: "relative",
        height: "52px",
        p: 8,
        border: function(t) {
            return "1px solid ".concat(t.colors.black);
        },
        borderRadius: "50px"
    };
    this.sticky = {
        top: [
            "var(--header-height)",
            "0"
        ],
        position: "sticky",
        bg: "white",
        zIndex: 2,
        px: 8,
        py: 4,
        mt: 4
    };
    this.title = {
        variant: "text.label.1",
        display: "inline-block"
    };
    this.selectedSort = {
        fontSize: 3,
        color: "mediumDarkGray",
        ml: 4
    };
    this.icon = {
        position: "absolute",
        right: 8,
        top: "50%",
        width: "24px",
        height: "24px",
        transform: "translateY(-50%)"
    };
}());

;// CONCATENATED MODULE: ./src/templates/collection/Filters/MobileFilters/MobileFilters.jsx







var MobileFilters = MobileFilters_theme_themed(function(param) {
    var theme = param.theme, collection = param.collection, collectionCategories = param.collectionCategories, hasHero = param.hasHero;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useFiltersSidebar */.JE)(), 2), toggleFiltersSidebar = ref[1].toggleFiltersSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": MobileFilters.displayName,
        sx: theme.wrapper,
        children: [
            collectionCategories,
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.sticky,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                    variant: "buttons.plain",
                    onClick: function() {
                        return toggleFiltersSidebar({
                            label: "Filter + Sort",
                            isFiltersAndSort: true
                        });
                    },
                    sx: theme.button,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h5",
                        sx: theme.title,
                        children: "Filter + Sort"
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CurrentFilters/* CurrentFilters */.c, {})
        ]
    });
});
MobileFilters.displayName = "MobileFilters";

;// CONCATENATED MODULE: ./src/templates/collection/Filters/MobileFilters/index.js


;// CONCATENATED MODULE: ./src/templates/collection/Filters/index.js



;// CONCATENATED MODULE: ./src/templates/collection/collection.jsx












function CollectionComponent(param) {
    var collection = param.collection, sections = param.sections;
    var ref, ref1, ref2, ref3;
    var settings = (0,dist.useSettings)();
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var sendViewCollectionEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewCollectionEvent;
    var gatedProducts = (0,hooks/* useGatedProduct */.sC)({
        gatedPage: gatedPage,
        currentUrl: collection.handle
    }).gatedProducts;
    var ref4 = (0,hooks/* usePickedSections */.FU)({
        firstOf: [
            "collection-hero",
            "collection-categories"
        ],
        sections: sections
    }), firstOf = ref4.firstOf, otherSections = ref4.otherSections;
    var ref5 = (0,collection_hooks/* useCollection */.Kx)(), products = ref5.products, merchandising = ref5.merchandising;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,collection_hooks/* useCollectionFilters */.PY)(), 2), clearSelectedFilters = ref6[1].clearSelectedFilters;
    var setSwatchesMap = (0,store/* useSetRecoilState */.Zl)(store/* default.swatchesMap */.ZP.swatchesMap);
    var swatches = (settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.swatches) || [];
    var collectionHero = (0,react.useMemo)(function() {
        if (firstOf["collection-hero"]) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            if ((ref = firstOf["collection-hero"]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.props) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.children) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.props) === null || ref5 === void 0 ? void 0 : ref5.cms) {
                firstOf["collection-hero"].props.children.props.children.props.cms.showBreadCrumb = true;
            }
            return firstOf["collection-hero"];
        }
        var haflMedia = otherSections === null || otherSections === void 0 ? void 0 : otherSections.find(function(s, i) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            if (s === null || s === void 0 ? void 0 : (ref = s.props) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.children) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.props) === null || ref4 === void 0 ? void 0 : ref4.cms) {
                s.props.children.props.children.props.cms.showBreadCrumb = true;
            }
            return (s === null || s === void 0 ? void 0 : (ref5 = s.props) === null || ref5 === void 0 ? void 0 : ref5["data-comp"]) === "half-media" && i === 0;
        });
        if (haflMedia) {
            return haflMedia;
        }
        return null;
    }, [
        firstOf["collection-hero"],
        otherSections
    ]);
    (0,react.useEffect)(function() {
        var _swatchesMap = swatches.reduce(function(map, swatch) {
            var ref;
            map[(ref = swatch.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()] = swatch;
            return map;
        }, {});
        setSwatchesMap(_swatchesMap);
    }, [
        JSON.stringify(swatches)
    ]);
    (0,react.useEffect)(function() {
        return function() {
            clearSelectedFilters();
        };
    }, [
        collection === null || collection === void 0 ? void 0 : collection.handle
    ]);
    (0,react.useEffect)(function() {
        sendViewCollectionEvent({
            products: collection === null || collection === void 0 ? void 0 : collection.products,
            collectionId: collection === null || collection === void 0 ? void 0 : collection.id
        });
    }, [
        "".concat(collection === null || collection === void 0 ? void 0 : collection.id).concat(!!(collection === null || collection === void 0 ? void 0 : (ref2 = collection.products) === null || ref2 === void 0 ? void 0 : ref2.length)),
        sendViewCollectionEvent, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": "CollectionTemplate",
        children: [
            firstOf["collection-hero"] || null,
            !collectionHero && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                isCollection: true,
                collectionTitle: collection === null || collection === void 0 ? void 0 : collection.title
            }),
            otherSections,
            !gatedProducts && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MobileFilters, {
                collection: collection,
                hasHero: !!firstOf["collection-hero"],
                collectionCategories: firstOf["collection-categories"] || null
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                sx: {
                    variant: "layout.content",
                    display: "block",
                    pt: [
                        0,
                        14,
                        15
                    ],
                    pb: [
                        14,
                        18,
                        "80px"
                    ]
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionGrid/* CollectionGrid */.U, {
                        products: gatedProducts || products,
                        merchandising: merchandising,
                        hasInitialProducts: !!((ref3 = collection.products) === null || ref3 === void 0 ? void 0 : ref3.length),
                        gatedPage: gatedPage
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SeoFooter, {})
                ]
            })
        ]
    });
}
function CollectionTemplate(param) {
    var collection = param.collection, renderSections = param.renderSections;
    var sections = renderSections();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionComponent, {
        sections: sections,
        collection: collection
    });
}

;// CONCATENATED MODULE: ./src/templates/collection/index.js

/* harmony default export */ var templates_collection = (CollectionTemplate);

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
;// CONCATENATED MODULE: ./src/pages/collections/[handle].jsx
/* provided dependency */ var process = __webpack_require__(4284);









// eslint-disable-next-line import/no-unresolved


var filterOutDraftProducts = function(product) {
    return product.status === "ACTIVE";
};
var __N_SSG = true;
function Collection(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var ref = (0,react.useState)(props.collection), collection = ref[0], setCollection = ref[1];
    var ref1 = (0,react.useState)(false), productsReady = ref1[0], setProductsReady = ref1[1];
    var setRecoilCollection = dist.store.recoil.useSetRecoilState(dist.store.state.collection);
    var collectionRef = (0,react.useRef)();
    collectionRef.current = collection;
    var fetchCache = (0,react.useRef)({});
    var fetchProduct = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(handle) {
            var isDev, siteUrl, host, response, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!fetchCache.current[handle]) return [
                            3,
                            3
                        ];
                        isDev = "production" === "development";
                        siteUrl = process.env.HOST_SITE_URL || "https://test.brumate.com/";
                        host = isDev ? "http://localhost:8080" : siteUrl;
                        return [
                            4,
                            fetch("".concat(host, "/json/products/").concat(handle, ".json"))
                        ];
                    case 1:
                        response = _state.sent();
                        _ = fetchCache.current;
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        _[handle] = _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            fetchCache.current[handle]
                        ];
                }
            });
        });
        return function fetchProduct(handle) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var n, i, promises, products, updatedCollection;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        n = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "18";
                        i = 0;
                        promises = collectionRef.current.products.map(function(product) {
                            if (!product.variants && i < n) {
                                i += 1;
                                return fetchProduct(product.handle);
                            }
                            return Promise.resolve(product);
                        });
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        products = _state.sent();
                        updatedCollection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collectionRef.current), {
                            products: products
                        });
                        setCollection(updatedCollection);
                        setRecoilCollection(updatedCollection);
                        return [
                            2,
                            updatedCollection
                        ];
                }
            });
        });
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasAllProductsOnLoad = collection.products.length < parseInt("18", 10);
    (0,react.useEffect)(function() {
        fetch("/json/collections/products/".concat(collection.handle, ".json")).then(function(response) {
            return response.json();
        }).then(function(result) {
            var remainingProducts = isPreview ? result : result.filter(filterOutDraftProducts);
            var fullCollection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                products: (0,_to_consumable_array/* default */.Z)(collection.products).concat((0,_to_consumable_array/* default */.Z)(remainingProducts))
            });
            setCollection(fullCollection);
            setRecoilCollection(fullCollection);
            setProductsReady(true);
        });
        return function() {
            setCollection(null);
            setRecoilCollection(null);
            setProductsReady(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        setRecoilCollection(collection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collection.handle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageHead */.yG, {
            page: props.page,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(templates_collection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                collection: collection,
                loadMore: loadMore,
                productsReady: hasAllProductsOnLoad || productsReady,
                renderSections: renderSections
            }))
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(593); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);